<template>
  <Flex>
    <Flex>
      <input
        type="checkbox"
        :id="checkboxId()"
        class="checkbox"
        :checked="isCurrentColumn()"
        :disabled="isOnlySelectedColumn()"
        @change="onColumnCheck($event)"
      />
      <label :for="checkboxId()" class="category-link">{{ $t(wordCloudColumn.name) }}</label>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { isEqual } from 'lodash'

export default {
  name: 'WordCloudColumnSelector',
  components: {
    Flex,
  },
  props: {
    wordCloudColumn: Object,
  },
  methods: {
    checkboxId() {
      return `checkbox${this.wordCloudColumn.attributePath}`
    },
    getRoute(wordCloudColumns) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          wordCloudColumns,
        },
      }
      return route
    },
    isCurrentColumn() {
      return [].concat(this.$route.query.wordCloudColumns).some((wordCloudColumn) => {
        return this.wordCloudColumn.attributePath === wordCloudColumn
      })
    },
    isOnlySelectedColumn() {
      return this.isCurrentColumn() && [].concat(this.$route.query.wordCloudColumns).length === 1
    },
    onColumnCheck(event, replace) {
      let wordCloudColumns = [].concat(this.$route.query.wordCloudColumns)
      if (this.isCurrentColumn()) {
        wordCloudColumns = wordCloudColumns.filter((wordCloudColumn) => {
          return this.wordCloudColumn.attributePath !== wordCloudColumn
        })
      }
      if (replace || !this.isCurrentColumn()) {
        wordCloudColumns = wordCloudColumns.concat(this.wordCloudColumn.attributePath)
      }
      const route = this.getRoute(wordCloudColumns)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.category-link {
  @apply break-words pl-2;
}
.checkbox {
  margin-top: 0.1rem;
}
</style>
